/**
 * ConfirmDialog - Generic confirmation dialog component
 */

import type { Component } from 'react';

const React = (window as any).React;
const ReactComponent = React.Component;

interface ConfirmDialogProps {
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    confirmText?: string;
    cancelText?: string;
    confirmButtonClass?: string;
    confirmAutoFocus?: boolean;
}

class ConfirmDialog extends ReactComponent<ConfirmDialogProps> {
    private confirmButtonRef = React.createRef();

    componentDidMount(): void {
        if (this.props.confirmAutoFocus) {
            this.confirmButtonRef.current?.focus();
        }
    }

    render(): any {
        const DialogComponent = (window as any).Dialog;
        if (!DialogComponent) return null;

        const confirmText = this.props.confirmText || 'Confirm';
        const cancelText = this.props.cancelText || 'Cancel';
        const confirmButtonClass = this.props.confirmButtonClass || 'btn';

        return React.createElement(DialogComponent, {
            title: this.props.title,
            onClose: this.props.onCancel,
            actionButtons: React.createElement(React.Fragment, null,
                React.createElement('button', {
                    className: 'btn',
                    onClick: this.props.onCancel
                }, cancelText),
                React.createElement('button', {
                    className: confirmButtonClass,
                    onClick: this.props.onConfirm,
                    ref: this.confirmButtonRef
                }, confirmText)
            ),
            closeOnBackdropClick: false
        },
            React.createElement('div', { style: { padding: '20px' } },
                React.createElement('p', { style: { margin: 0, color: 'var(--main-text-color)' } }, this.props.message)
            )
        );
    }
}

(window as any).ConfirmDialog = ConfirmDialog;
export default ConfirmDialog;
